import { render } from "./bulletChat.vue?vue&type=template&id=252e62ff&scoped=true"
import script from "./bulletChat.vue?vue&type=script&lang=js"
export * from "./bulletChat.vue?vue&type=script&lang=js"

import "./bulletChat.vue?vue&type=style&index=0&id=252e62ff&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252e62ff"]])

export default __exports__